import { IBuyboxViewProps, IBuyboxData } from '@msdyn365-commerce-modules/buybox';
import { IBuyboxProps } from '../../definition-extensions/buybox.ext.props.autogenerated';
import { ICartAndActions } from '../types/buybox';
import { PropertyMaxLength, PropertyMinLength, PropertyType } from '../propertyTypeEnum';
import { format } from '@msdyn365-commerce/retail-proxy';

export default (cartAndAction: ICartAndActions, props: React.PropsWithChildren<IBuyboxViewProps & IBuyboxProps<IBuyboxData>>) => {
    const { propertyType, ldcPlan, setLdcPlan, plan, setPlan, unit, setUnit } = cartAndAction;
    const { lookFor, setLookFor, searchAddressQuery, setSearchAddressQuery } = cartAndAction;
    const { emptyOrInvalidSearchAddressErrorMessage } = props.resources;
    let isValidationPass = true;
    switch (propertyType) {
        case PropertyType.address:
            if (searchAddressQuery.value.length <= 0 || !searchAddressQuery.isAddressSelected) {
                setSearchAddressQuery(prevSt => ({ ...prevSt, errorMessage: emptyOrInvalidSearchAddressErrorMessage }));
                isValidationPass = false;
            } else {
                setSearchAddressQuery(prevSt => ({ ...prevSt, errorMessage: '' }));
            }
            break;
        case PropertyType.legalDescription:
            if (plan.value.length <= 0) {
                setPlan(prevState => ({ ...prevState, errorMessage: props.resources.planErrorMessage }));
                isValidationPass = false;
            } else {
                setPlan(prevState => ({ ...prevState, errorMessage: '' }));
            }
            break;
        case PropertyType.legalDescriptionCondo:
            if (ldcPlan.value.length <= 0) {
                setLdcPlan(prevState => ({ ...prevState, errorMessage: props.resources.planErrorMessage }));
                isValidationPass = false;
            } else {
                setLdcPlan(prevState => ({ ...prevState, errorMessage: '' }));
            }
            if (unit.value.length <= 0) {
                setUnit(prevState => ({ ...prevState, errorMessage: props.resources.unitErrorMessage }));
                isValidationPass = false;
            } else {
                setUnit(prevState => ({ ...prevState, errorMessage: '' }));
            }

            break;
        case PropertyType.rollNumber:
            {
                const lookForLength = lookFor.value.length;
                if (lookForLength <= 0) {
                    setLookFor(prevState => ({ ...prevState, errorMessage: props.resources.rollNumberErrorMessage }));
                    isValidationPass = false;
                } else if (lookForLength != PropertyMaxLength.rollNumber) {
                    setLookFor(prevState => ({
                        ...prevState,
                        errorMessage: format(
                            props.resources.rollNumberLengthErrorMessage,
                            props.resources.rollNumberLabel,
                            PropertyMaxLength.rollNumber
                        )
                    }));
                    isValidationPass = false;
                } else {
                    setLookFor(prevState => ({ ...prevState, errorMessage: '' }));
                }
            }
            break;

        case PropertyType.lincNumber:
            {
                const lookForLength = lookFor.value.length;
                if (lookForLength <= 0) {
                    setLookFor(prevState => ({ ...prevState, errorMessage: props.resources.lincNumberErrorMessage }));
                    isValidationPass = false;
                } else if (!(lookForLength >= PropertyMinLength.lincNumber && lookForLength <= PropertyMaxLength.lincNumber)) {
                    setLookFor(prevState => ({
                        ...prevState,
                        errorMessage: format(
                            props.resources.lengthErrorMessage,
                            props.resources.lincNumberLabel,
                            PropertyMinLength.lincNumber,
                            PropertyMaxLength.lincNumber
                        )
                    }));
                    isValidationPass = false;
                } else {
                    setLookFor(prevState => ({ ...prevState, errorMessage: '' }));
                }
            }
            break;
        case PropertyType.titleNumber:
            {
                const lookForLength = lookFor.value.length;
                if (lookForLength <= 0) {
                    setLookFor(prevState => ({ ...prevState, errorMessage: props.resources.titleNumberErrorMessage }));
                    isValidationPass = false;
                } else if (!(lookForLength >= PropertyMinLength.titleNumber && lookForLength <= PropertyMaxLength.titleNumber)) {
                    setLookFor(prevState => ({
                        ...prevState,
                        errorMessage: format(
                            props.resources.lengthErrorMessage,
                            props.resources.titleNumberLabel,
                            PropertyMinLength.titleNumber,
                            PropertyMaxLength.titleNumber
                        )
                    }));
                    isValidationPass = false;
                } else {
                    setLookFor(prevState => ({ ...prevState, errorMessage: '' }));
                }
            }
            break;
        case PropertyType.cpid:
            {
                const lookForLength = lookFor.value.length;
                if (lookForLength <= 0) {
                    setLookFor(prevState => ({ ...prevState, errorMessage: props.resources.cpidErrorMessage }));
                    isValidationPass = false;
                } else if (!(lookForLength >= PropertyMinLength.cpid && lookForLength <= PropertyMaxLength.cpid)) {
                    setLookFor(prevState => ({
                        ...prevState,
                        errorMessage: format(
                            props.resources.lengthErrorMessage,
                            props.resources.cpidLabel,
                            PropertyMinLength.cpid,
                            PropertyMaxLength.cpid
                        )
                    }));
                    isValidationPass = false;
                } else {
                    setLookFor(prevState => ({ ...prevState, errorMessage: '' }));
                }
            }
            break;
        default:
            break;
    }
    return isValidationPass;
};
